// File: client/src/variants/party/partyModifiers.js
//
// Party Chess uses the shared modifier catalog plus a few upbeat, party-only
// modifiers. All are pure and seedable. Party modifiers may be 'board' (mutate the
// board), 'rule' (per-turn flag), or 'grant' (a one-off benefit to the CHOOSER,
// handled by the runtime, e.g. an extra move).

import { BOARD_MODIFIERS, knightOnly } from '../../platform/modifiers';

function emptySquares(board) {
  const out = [];
  for (let r = 0; r < 8; r++) for (let c = 0; c < 8; c++) if (!board[r][c]) out.push({ row: r, col: c });
  return out;
}

// Spawn an extra queen for the chooser on a random empty square.
export const extraQueen = {
  id: 'extra_queen', name: 'Extra Queen', icon: '👑', kind: 'board',
  describe: 'Gain a bonus queen on a random empty square.',
  apply(board, rng, ctx) {
    const color = (ctx && ctx.chooser) || 'white';
    const empties = emptySquares(board);
    if (!empties.length) return 'No room for an extra queen.';
    const sq = empties[Math.floor(rng() * empties.length)];
    board[sq.row][sq.col] = color === 'white' ? 'Q' : 'q';
    return `${color} gained an extra queen!`;
  },
};

// The chooser gets a bonus move this turn (runtime keeps the turn open).
export const bonusTurn = {
  id: 'bonus_turn', name: 'Bonus Turn', icon: '➕', kind: 'grant', grant: 'bonus_move',
  describe: 'Take an extra move right now.',
  apply() { return 'Bonus move granted!'; },
};

// Gift: promote one of the chooser's random pawns.
export const gift = {
  id: 'gift', name: 'Gift', icon: '🎁', kind: 'board',
  describe: 'A random one of your pawns is promoted to a queen.',
  apply(board, rng, ctx) {
    const color = (ctx && ctx.chooser) || 'white';
    const pawn = color === 'white' ? 'P' : 'p';
    const mine = [];
    for (let r = 0; r < 8; r++) for (let c = 0; c < 8; c++) if (board[r][c] === pawn) mine.push({ row: r, col: c });
    if (!mine.length) return 'No pawns to gift.';
    const t = mine[Math.floor(rng() * mine.length)];
    board[t.row][t.col] = color === 'white' ? 'Q' : 'q';
    return `${color} received a gift: a pawn became a queen!`;
  },
};

// The party pool: upbeat party modifiers + a friendly subset of the shared board
// modifiers (the destructive Meteor is excluded to keep the mood light) + Knight Fever.
const SHARED_FRIENDLY = BOARD_MODIFIERS.filter(m => m.id !== 'meteor');

export const PARTY_MODIFIERS = [
  extraQueen, bonusTurn, gift, knightOnly, ...SHARED_FRIENDLY,
];

/** Pick N distinct party modifiers to offer as a vote. */
export function offerChoices(rng, n = 3, pool = PARTY_MODIFIERS) {
  const copy = [...pool];
  const out = [];
  for (let i = 0; i < n && copy.length; i++) {
    out.push(copy.splice(Math.floor(rng() * copy.length), 1)[0]);
  }
  return out;
}
